/**
 * Generate a UUID v4 string.
 * Based on https://stackoverflow.com/a/8809472
 *
 * @returns UUID v4 string in the format xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 */
export const generateUUID = (): string => { // Public Domain/MIT
    let timestamp = new Date().getTime() // Timestamp
    let microseconds = (performance && performance.now && (performance.now() * 1000)) || 0 // Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
        let randomBits = Math.random() * 16 // random number between 0 and 16
        if (timestamp > 0) { // Use timestamp until depleted
            randomBits = (timestamp + randomBits) % 16 | 0
            timestamp = Math.floor(timestamp / 16)
        } else { // Use microseconds since page-load if supported
            randomBits = (microseconds + randomBits) % 16 | 0
            microseconds = Math.floor(microseconds / 16)
        }
        return (character === 'x' ? randomBits : (randomBits & 0x3 | 0x8)).toString(16)
    })
}

/**
 * Get a random alphanumeric string.
 *
 * @param length - Desired string length (default: 8)
 * @returns Random alphanumeric string of the requested length
 */
export const ransomString = (length = 8): string => (
    Array(length + 1).join((Math.random().toString(36) + '00000000000000000').slice(2, 18)).slice(0, length)
)
